import { render, staticRenderFns } from "./strongbox-card.vue?vue&type=template&id=e88602fa&"
import script from "./strongbox-card.vue?vue&type=script&lang=js&"
export * from "./strongbox-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports